export enum QuestionType {
    Faq = 0,
    Raq = 1
}